import React, { memo } from 'react';
import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme, IModalConfirmationMessageProps, ModalConfirmationMessage } from '@alycecom/ui';

import useResponsive from '../../hooks/useResponsive';

const useStyles = makeStyles<AlyceTheme, { isMobile: boolean }>(({ palette, spacing }) => ({
  avatar: {
    backgroundColor: palette.green.dark,
  },
  root: ({ isMobile }) => ({
    width: isMobile ? '100%' : 500,
    borderTop: `4px solid ${palette.green.dark}`,
  }),
  submitButton: ({ isMobile }) => ({
    backgroundColor: palette.green.dark,
    paddingLeft: spacing(1),
    paddingRight: spacing(1),
    marginLeft: '0px !important',
    width: isMobile ? '100%' : 220,
    border: 'none',
    marginBottom: isMobile ? spacing(1) : 0,
    '&:hover': {
      backgroundColor: palette.green.dark,
    },
    whiteSpace: 'nowrap',
    '&>span>span': {
      lineHeight: '1.3 !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
  cancelButton: ({ isMobile }) => ({
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    width: isMobile ? '100%' : 'auto',
    marginRight: isMobile ? 0 : spacing(2),
    maxWidth: isMobile ? '100%' : 220,
    whiteSpace: 'nowrap',
    '&>span>span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
  actions: ({ isMobile }) => ({
    flexDirection: isMobile ? 'column-reverse' : 'row',
    justifyContent: isMobile ? 'space-between' : 'flex-end',
  }),
}));

export interface ISuccessModalProps extends IModalConfirmationMessageProps {
  children: React.ReactNode;
}

const SuccessModal = ({ children, ...modalProps }: ISuccessModalProps) => {
  const { isMobile } = useResponsive();
  const { palette: colors } = useTheme();
  const customClasses = useStyles({ isMobile });

  return (
    <ModalConfirmationMessage
      width="100%"
      backdropStyles={{ top: 0, backgroundColor: colors.common.black }}
      icon="eye-slash"
      customClasses={customClasses}
      submitButtonsProps={{ id: 'success-submit-button' }}
      submitButtonText="Ok"
      cancelButtonText="Cancel"
      {...modalProps}
    >
      {children}
    </ModalConfirmationMessage>
  );
};

export default memo(SuccessModal);
